module.exports = __webpack_public_path__ + "media/icons/icon_yayoi-040ea6c7.png";